export class User {
  id: number;
  firstName: string;
  lastName: string;
  title: string;
  description: string;
  email: string;
  deleted: boolean;
  roles: Role[];
  token: string;
}

export class UserOrganization {
  organizationId: number;
  userId: number;
}

export enum Role {
  Administrator = 'Admin',
  Advertiser = 'Advertiser',
  Publisher = 'Publisher',
  CreativeAdmin = 'CreativeAdmin',
}